// Feeds the cursor position into --glow-x/--glow-y on hovered .glass-card
// elements so their radial highlight (see index.css) tracks the mouse.
// One delegated listener for the whole site; skipped on touch devices.
export const initCardGlow = () => {
  if (window.matchMedia('(pointer: coarse)').matches) return undefined;
  const onMove = (e) => {
    const card = e.target.closest?.('.glass-card');
    if (!card) return;
    const rect = card.getBoundingClientRect();
    card.style.setProperty('--glow-x', `${e.clientX - rect.left}px`);
    card.style.setProperty('--glow-y', `${e.clientY - rect.top}px`);
  };
  document.addEventListener('mousemove', onMove, { passive: true });
  return () => document.removeEventListener('mousemove', onMove);
};
